import * as React from "react"
import { makeStyles } from "@material-ui/core"
import theme from "../../theme"
import { CommonTableTwo } from "../table"
import { Pagination } from "@material-ui/lab"
import { useDispatch, useSelector } from "react-redux"
import { getPaymentListAction } from "../../containers/dashboard/action"
import { moneyValue } from "../../utils"
import CommonDatePicker from "../datepicker"
import CommonDropDown from "../dropdown"
import EndDatePicker from "../datepicker/endDatePicker"
import moment from "moment"

const useStyles = makeStyles({
  root: {
    width: "calc(100vw - 350px)",
    borderRadius: "15px",
    backgroundColor: theme.colors.White,
    padding: "12px",
    boxShadow: " 20px 20px 60px #e6e6e6,-20px -20px 60px #ffffff",
    marginRight: "220px",
    marginTop: "15px"

  },
  tabHeader: {
    fontSize: "24px"
  },
  groupHeader: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    width: "100%",
    justifyContent: "space-between"
  },
  pickerGroup: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap"
  },
  dateGroup: {
    display: "flex",
    flexDirection: "col",
    flexWrap: "nowrap"
  },
  textDodger: {
    color: theme.colors.DodgerBlue

  },
  dropdown: {
    minWidth: "200px"
  }
})

const paymentStates = [
  {
    value: 'PENDING',
    label: 'Pending'
  },
  {
    value: 'SETTLED',
    label: 'Settled'
  },
  {
    value: 'DECLINED',
    label: 'Declined'
  }
]

export default function UserTransactionBoard({
  userId,
  userName
}) {
  const classes = useStyles()
  const [filters, setFilters] = React.useState({
    page: 1,
    page_size: 3,
    history: true,
    intent: "WITHDRAW"
  })

  const getPaymentListActionMethod = React.useCallback((data) => getPaymentListAction(data), [filters])

  const dispatch = useDispatch()
  const dashboardReducer = useSelector((state) => state.dashboardReducer)

  React.useEffect(() => {
    if (userId) {
      dispatch(getPaymentListActionMethod({...filters, employee_id: userId}))
    }
  }, [filters, userId])

  return (
    <section className={classes.root}>
      <div className={classes.groupHeader}>
        <header className={classes.tabHeader}>Transactions</header>
        <div className={classes.pickerGroup}>
          <CommonDropDown
            placeholder={"State"}
            options={paymentStates}
            value={paymentStates.find((v) => v?.value === filters?.state)}
            onChange={(value) => {
              setFilters(st => {
                if (Object.hasOwn(filters, "state") && !value) {
                  const { state, ...rest } = filters
                  return rest
                }
                return ({ ...st, state: value?.value })
              });
            }}
            isClearable={true}
            className={classes.dropdown}
          />
          <div className={classes.dateGroup}>
            <small className={classes.textDodger}>Start Date</small>
            <CommonDatePicker
              startDate={filters?.start_time}
              setStartDate={(date) => {
                setFilters(
                  state => ({ ...state, start_time: `${(new Date(date).toISOString().split("T")[0])}` })
                )
              }}
            /></div>
          <div className={classes.dateGroup}>
            <small className={classes.textDodger}>End Date</small>
            <EndDatePicker
              endDate={filters?.end_time}
              setEndDate={(date) => {
                setFilters(
                  state => ({ ...state, end_time: `${(new Date(date).toISOString().split("T")[0])}` })
                )
              }}
              maxDate={new Date()}
            />
          </div>

        </div>

      </div>
      <CommonTableTwo
        data={dashboardReducer?.paymentList?.data || []}
        columns={
          [
            {
              Header: "Amount",
              HeaderCell: (data) => (
                <div className={classes.headerName}>{data}</div>
              ),
              Cell: (data, row) => (
                <div
                >
                  <sup>{row?.company?.currency}</sup>{moneyValue(row?.amount)}
                </div>
              ),
            },
            {
              Header: "Net",
              HeaderCell: (data) => (
                <div className={classes.headerName}>{data}</div>
              ),
              Cell: (data, row) => (
                <div
                >
                  <sup>{row?.company?.currency}</sup>{moneyValue(row?.net)}
                </div>
              ),
            },
            {
              Header: "Fees",
              HeaderCell: (data) => (
                <div className={classes.headerName}>{data}</div>
              ),
              Cell: (data, row) => (
                <div
                >
                  <sup>{row?.company?.currency}</sup>{moneyValue(row?.fees)}
                </div>
              ),
            },
            {
              Header: "Intent",
              HeaderCell: (data) => (
                <div className={classes.headerName}>{data}</div>
              ),
              Cell: (data, row) => (
                <div
                >
                  {row?.intent}
                </div>
              ),
            },
            {
              Header: "State",
              HeaderCell: (data) => (
                <div className={classes.headerName}>{data}</div>
              ),
              Cell: (data, row) => (
                <div
                >
                  {row?.state}
                </div>
              ),
            },
            {
              Header: "Created At",
              HeaderCell: (data) => (
                <div className={classes.headerName}>{data}</div>
              ),
              Cell: (data, row) => (
                <div
                >
                  {row?.created_at
                    ? moment(row?.created_at).format("DD/MM/YYYY LT")
                    : "----------"}
                </div>
              ),
            },
            {
              Header: "Settled At",
              HeaderCell: (data) => (
                <div className={classes.headerName}>{data}</div>
              ),
              Cell: (data, row) => (
                <div
                >
                  {row?.settled_at
                    ? moment(row?.settled_at).format("DD/MM/YYYY LT")
                    : "----------"}
                </div>
              ),
            },
            {
              Header: "Declined At",
              HeaderCell: (data) => (
                <div className={classes.headerName}>{data}</div>
              ),
              Cell: (data, row) => (
                <div
                >
                  {row?.declined_at
                    ? moment(row?.declined_at).format("DD/MM/YYYY LT")
                    : "----------"}
                </div>
              ),
            },
          ]
        }
      />
      <div className={"pagination"}>
        <Pagination
          page={filters.page}
          count={Math.ceil((dashboardReducer?.paymentList?.count || 1) / filters.page_size)}
          showFirstButton
          showLastButton
          onChange={(event, value) => {
            setFilters((state) => ({ ...state, page: value }))
          }}
        />
      </div>
    </section>
  )
}